export default "__VITE_ASSET__DqAizqz___"